export default __webpack_public_path__ + "static/media/icon_notification_chat.304fccff.svg";